<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form" style="margin-left: -14px;margin-right: -6px;">
            <!-- Label -->
            <div class="table-search-form-flex label-type">
              <div class="table-search-form-label">
                {{$I18n("filter_type")}}
              </div>
            </div>
            <!-- 类型查询的类型选择 -->
            <div class="table-search-form-flex">
              <div class="table-search-form-box">
                <el-select v-model="searchForm.searchType">
                  <el-option value="1" :label="$I18n('order_id')"></el-option>
                  <el-option value="2" :label="$I18n('pay_order_id')"></el-option>
                  <el-option value="3" :label="$I18n('app_id')"></el-option>
                  <el-option value="4" :label="$I18n('buy_user_id')"></el-option>
                  <el-option value="5" :label="$I18n('umid')"></el-option>
                  <el-option value="6" :label="$I18n('platform_order_id_2')"></el-option>
                </el-select>
              </div>
            </div>
            <!-- 表单-选择栏-查询类型{1:订单ID, 2:支付订单号, 3:APP ID, 4:购买用户ID, 5:设备ID} -->
            <div class="table-search-form-flex">
              <div class="table-search-form-box">
                <el-input v-model="searchForm.searchValue" :placeholder="searchValuePlaceHolder"/>
              </div>
            </div>
            <!-- Label -->
            <div class="table-search-form-flex label-type">
              <div class="table-search-form-label">
                {{$I18n("pack_type")}}
              </div>
            </div>
            <!-- 项目类型选择 -->
            <div class="table-search-form-flex">
              <div class="table-search-form-box">
                <el-select v-model="searchForm.category_id">
                  <el-option :value="0" :label="$I18n('all')"></el-option>
                  <el-option v-for="item in orderClass" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </div>
            </div>
            <!-- Label -->
            <div class="table-search-form-flex label-type">
              <div class="table-search-form-label">
                {{$I18n("order_state")}}
              </div>
            </div>
            <!-- 订单状态 {0:查询全部, 1:已支付, 2:支付失败, 3:已撤销, 4:未支付} -->
            <div class="table-search-form-flex">
              <div class="table-search-form-box">
                <el-select v-model="searchForm.order_state">
                  <el-option value="0" :label="$I18n('all')" />
                  <el-option value="1" :label="$I18n('payed')" />
                  <el-option value="2" :label="$I18n('fail')" />
                  <el-option value="3" :label="$I18n('has_cancel')" />
                  <el-option value="4" :label="$I18n('undo')" />
                  <el-option value="5" :label="$I18n('refunded')" />
                </el-select>
              </div>
            </div>
            <!-- Label -->
            <div class="table-search-form-flex label-type">
              <div class="table-search-form-label">
                {{$I18n("company")}}
              </div>
            </div>
            <!-- 所属企业 -->
            <div class="table-search-form-flex">
              <div class="table-search-form-box">
                <el-select v-model="searchForm.comp_id">
                  <el-option value="" :label="$I18n('all')"/>
                  <el-option v-for="comp in compData" :key ="comp.comp_id" :value="comp.comp_id" :label="comp.comp_name"/>
                </el-select>
              </div>
            </div>
            <!-- Label -->
            <div class="table-search-form-flex label-type">
              <div class="table-search-form-label">
                {{$I18n("order_create_time")}}
              </div>
            </div>
            <!-- 表单-日期范围选择-创建时间 -->
            <div class="table-search-form-flex">
              <div class="table-search-form-box" style="width: 230px;">
                <el-date-picker :picker-options="pickerOptions" v-model="searchForm.create_time" class="md-date-form-item" align="left" type="daterange" range-separator="~" prefixIcon="no" value-format="yyyy-MM-dd HH:mm:ss" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
              </div>
            </div>
          </div>


          <!-- 按钮 -->
          <div class="md-layout card-form">
            <!-- 检索按钮 {小屏幕模式} -->
            <div v-if="$root.state.mobile" class="md-layout-item left-layout-item md-xsmall-size-50">
              <md-button class="md-info md-just-icon md-round right-button" @click="form_changeSearchData">
                <md-icon>search</md-icon>
              </md-button>
            </div>
            <!-- 导出订单按钮 {小屏幕模式} -->
            <div v-if="$root.state.mobile" class="md-layout-item left-layout-item md-xsmall-size-50">
              <md-button class= "left-icon md-info" @click="get_file">
                <md-icon>file_download</md-icon>
                {{$I18n("create_xls")}}
              </md-button>
            </div>
            <!-- 导出记录按钮 {小屏幕模式} -->
            <div v-if="$root.state.mobile" class="md-layout-item left-layout-item md-xsmall-size-50">
              <md-button class="md-info" @click="form_downloadXlsx">
                <md-icon>file_download</md-icon>
                {{$I18n("export_record")}}
              </md-button>
            </div>
            <!-- 按钮 {大屏幕模式} -->
            <div v-if="!$root.state.mobile" class="md-layout md-layout-item left-layout-item" :style="{'justify-content': 'flex-end'}">
                <md-button class="left-icon md-info" @click="form_changeSearchData">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
                <md-button class="left-icon md-info" @click="get_file">
                  <md-icon>file_download</md-icon>
                  {{$I18n("create_xls")}}
                </md-button>
                <md-button class="left-icon md-info" @click="form_downloadXlsx">
                  <md-icon>file_download</md-icon>
                  {{$I18n("export_record")}}
                </md-button>

                <md-button class="left-icon md-info" @click="form_uploadOrder">
                  <md-icon>file_upload</md-icon>
                  {{$I18n("import_order")}}
                </md-button>
                <md-button class="left-icon md-info" @click="form_uploadOrderList">
                  <md-icon>file_upload</md-icon>
                  {{$I18n("import_record")}}
                </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 订单数据卡片 -->
    <div class="md-layout-item md-size-100" v-for="(order,index) in tableData" :key="index">
      <md-card class="order-card" >
        <!-- 卡片-头部 -->
        <md-card-header>
          <!-- 创建时间 | 商品订单号 | 支付时间 | 支付订单号 | 区域 -->
          <div class="md-subhead no-left">
            <div class="order-card-title" style="margin-right: 150px;">
              <span class="order-card-title-span">
                {{$I18n("created_thing_time")}}:{{order.create_time}}
              </span>
              <span class="order-card-title-span">
                {{$I18n("order_id")}}:{{order.order_id}}
              </span>
              <span class="order-card-title-span" v-if="!!order.pay_time">
                {{$I18n("pay_time")}}:{{order.pay_time}}
              </span>
              <span class="order-card-title-span">
                {{$I18n("pay_order_id")}}:{{order.pay_order_id}}
              </span>
              <span class="order-card-title-span">
                {{$I18n("pay_plat_no")}}:{{order.platform_order_id}}
              </span>
              <span class="order-card-title-span">
                {{$I18n("zone")}}:{{$I18n(order.zone)}}
              </span>
            </div>
          </div>
          <!-- 订单状态 (显示在右上角) -->
          <p :class="{success: order.order_state == 1, warning : order.order_state != 1}" class="category order-card-title-state">
            {{order.state}}
          </p>
        </md-card-header>
        <!-- 间隔线 -->
        <!-- <div class="line"></div> -->

        <!-- 卡片-主体 -->
        <md-card-content class="md-layout order-info-body" >
          <!-- 图片 -->
          <div class="md-layout-item md-size-10 md-xsmall-size-100">
            <img :style="{'max-width':'300px'}" src="/img/timg.jpg">
          </div>
          <!-- 商品名称 | 所属公司 -->
          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <div>{{$I18n("pack_type")}}: {{order.order_class_name}}</div>
            <div>{{$I18n("pack_info")}}: {{order.name}}</div>
            <!-- <div>{{$I18n("pack_type")}}: {{order.company_name}}</div> -->
          </div>
          <!-- 购买人ID | APP ID (没有的时候不显示) -->
          <div class="md-layout-item md-size-30 md-xsmall-size-100" v-if="order.user_id || order.app_id">
            <div v-if="order.user_id" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{$I18n("buy_id")}}: {{order.user_id}}</div>
            <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{$I18n("company")}}: {{order.comp_name}}</div>
          </div>
          <!-- UID -->
          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <div>{{$I18n("umid")}}: {{order.link_id}}</div>
            <div v-if="order.app_name">{{"APP"}}: {{order.app_name}}</div>
          </div>
          <!-- 订单价格 | 数量 -->
          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <div>{{$I18n("order_type")}}: {{$I18n("order_type_"+order.order_type)}}</div>
          </div>
        </md-card-content>
        <!-- 卡片-底部  保存时间 | 有效时长 | 支付平台 | 商品成本 | 商品总额 | 实际收款 -->
        <md-card-actions>
          <!-- style="line-height: 41px;" -->
          <div class="foot-box" :style="{'line-height': order.order_state == 1 && order.category_id == 101 && order.order_type == 2 ?'41px' :'none'}"> 
            <!-- <span v-if="order.attr.lifecycle">{{$I18n("save_time")}}:{{order.attr.lifecycle}}{{$I18n("day")}}</span> -->
            <!-- <span class="foot-box-left">{{$I18n("validity_day")}}:{{order.months}}{{$I18n("a_month")}}</span> -->
            <div class="foot-box-right" :style="{'display':'flex'}">
              <div>{{$I18n("pay_type")}}:{{order.pay_platform_name}}</div>
              <div v-if="order.comp_price">{{$I18n("cost")}}:¥{{order.comp_price}}</div>
              <div>{{$I18n("commod_price")}}:{{$I18n("money_type_" + order.currency)}}{{order.order_price}}</div>
              <div>{{$I18n("fact_price")}}:{{$I18n("money_type_" + order.currency)}}{{order.fact_price}}</div>
              <md-button v-if='order.order_state == 1 && order.category_id == 101 && (order.order_type == 2 || order.order_type == 1)' class="md-info" @click="() => goRefund(order)">
                {{$I18n("req_ref")}}
              </md-button>
            </div>
          </div>
        </md-card-actions>
      </md-card>
    </div>
    <!-- 分页 -->
    <div class="md-layout-item md-size-100" >
      <md-card>
        <table-page :total="total" v-model="currentPage" :pageSize="pageSize"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :large = "openModalType==='import'"
      :right = "openModalType==='import' || openModalType==='create_xls'"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 导出xls的选项  -->
        <div v-if="openModalType === 'create_xls'">
          <div class="md-layout"> 
            <common-form-item 
              v-for="item in form_modalData" 
              v-model="exportForm.Form[item.keys]" 
              :error="exportForm.Error[item.keys]" 
              :key="item.keys" v-bind="item"
            />
            <!-- 表单-日期范围选择-创建时间 -->
            <div class="md-layout md-layout-item md-size-100">
              <label class="md-layout-item md-size-100 md-form-label">
                {{$I18n("time_range")}}<i :style="{color: 'red'}">*</i>:
                <!-- 这个月的 -->
                <div class="md-chip md-info" @click="() => jump_month(1)">
                  <div class="md-ripple">{{$I18n("this_month")}}</div>
                </div>
                <!-- 上个月的 -->
                <div class="md-chip md-info" @click="() => jump_month(2)">
                  <div class="md-ripple">{{$I18n("last_month")}}</div>
                </div>
              </label>
              <div class="md-layout-item md-size-100 md-form-item">
                <md-field class="md-theme-default md-has-value">
                  <el-date-picker :picker-options="exportPickerOptions" v-model="exportForm.Form.create_time" class="md-date-form-item" align="left" type="daterange" prefixIcon="no" range-separator="~" value-format="yyyy-MM-dd HH:mm:ss" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
                </md-field>
              </div>
            </div>
          </div>
        </div>
        <!-- 导入文件表格弹窗 -->
        <div v-else>
          <!-- 弹窗-表格
            申请时间
            企业
            申请人
            状态
            操作 {下载文件}
           -->
          <md-table v-model="modalTableData" class="left-table">
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="$I18n('apply_time')">
                <div :style="{'textAlign':'left'}">{{ item.create_time }}</div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('company')">
                <div :style="{'textAlign':'left'}">{{ item.comp_name }}</div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('applicant')">
                <div :style="{'textAlign':'left'}">{{ item.user_id }}</div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('state')">
                <div :style="{'textAlign':'left'}">{{ item.state_name }}</div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')">
                <div v-if="item.file_url" :style="{'textAlign':'left'}">
                  <a :download="item.file_url.split('/').pop()" :href="item.file_url">{{$I18n("download_file")}}</a>
                </div>
                <div v-else :style="{'textAlign':'left'}">{{$I18n('download_file')}}</div>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <table-page :total="import_total" v-model="import_currentPage" :pageSize="import_pageSize"/>
        </div>
      </template>
    </simple-modal>
    <simple-modal 
      ref    = "import_order"
      :title = "$I18n('import_order')"
      :right = "true"
      @submit= "modal_import_submit"
    >
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>
          <common-form-item 
            v-for="item in form_importModalData" 
            v-model="uploadForm.Form[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field v-if="item.key ==='file'" :class="{'md-error' : uploadForm.Error.file}">
              <md-input v-model="uploadForm.Form.file" @click="modal_file_input" readonly :placeholder="$I18n('click_select_file')"/>
              <md-icon v-if="uploadForm.Error.file">clear</md-icon>
            </md-field>
          </common-form-item>
          <input :style="{display:'none'}" type="file" ref="inputFile" @change="onChange" />
        </div>
      </template>
      <template slot="footer-btn">
        <div :style="{'position':'absolute','left': '36px'}">
          <span :style="{'margin-right': '24px'}">
            {{$I18n("price")}} : {{comp_price.toFixed(2)}}
          </span>
        </div>
        <a :download="$I18n('frame')" href="/files/uid.xlsx">
          <md-button class="md-info left-icon">{{$I18n("frame")}}</md-button>
        </a>
      </template>
    </simple-modal>
    <simple-modal 
      ref    = "import_record"
      :title = "$I18n('import_record')"
      :large = "true"
      :right = "true"
    >
      <template slot="body">
        <md-table v-model="importableData" class="left-table">
          <md-table-row slot="md-table-row" slot-scope="{item}">
            <md-table-cell :md-label="$I18n('import_id')">{{ item.id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('company')">{{ item.comp_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('spec_name')">{{ item.spec_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('import_file')">
              <!-- 有下载地址 -->
              <a v-if="item.file_path" :style='{color:"blue"}' :download="`import-${item.id}.xlsx`" :href="item.file_path">
                {{`import-${item.id}.xlsx`}}
              </a>
              <!-- 没有下载链接 -->
              <span v-else>{{$I18n("is_none")}}</span>
            </md-table-cell>
            <!-- 显示样式 : 总数/成功条数(绿色)/失败条数(红色) -->
            <md-table-cell :md-label="`${$I18n('mng_num')}/${$I18n('succ_num')}/${$I18n('fail_num')}`">
              {{item.mng_num ?item.mng_num :0}}/
              <span :style='{color:"green"}'>{{item.succ_num ?item.succ_num :0}}</span>/
              <span :style='{color:"red"}'>{{item.fail_num ?item.fail_num :0}}</span>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('import_state')">
              <span v-if="item.state == 1" :style="{color:'green'}">
                {{$I18n("has_sync_database")}}
              </span>
              <span v-else-if="item.state == 2" :style="{color:'red'}">
                {{$I18n("has_error_row")}}
              </span>
              <span v-else-if="item.state == 3" :style="{color:'red'}">
                {{$I18n("file_error")}}
              </span>
              <span v-else-if="item.state == 4" :style="{color:'red'}">
                {{$I18n("wait_sync_database")}}
              </span>
              <span v-else-if="item.state == 5" :style="{color:'red'}">
                {{$I18n("is_sync_database")}}
              </span>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('import_date')">{{ item.create_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
        </md-table>

        <table-page :total="import_record_total" v-model="import_record_currentPage" :pageSize="import_pageSize"/>
      </template>
    </simple-modal>
    <simple-modal 
      ref    = "refund"
      :title = "$I18n('req_ref')"
      :right = "true"
      @submit= "modal_refund_order"
    >
      <template slot="body">
        <common-form-item 
          v-for="item in form_refundData" 
          v-model="refundOrderForm.Form[item.keys]" 
          :key="item.keys" v-bind="item"
        >
        </common-form-item>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { timestampToString, nMonthsAgo,nDaysAgo, FormClass } from "@/common/tools.js";
export default {
  data() {
    return {
      pickerOptions: { // 时间范围选择
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      refundOrderForm:new FormClass({
        price:{
          init: "",
          check: "required",
        },
      }),
      exportPickerOptions: { // 导出文件的 可选时间 {半年内}
        disabledDate(time) {
          return time.getTime() > Date.now() || time.getTime() < nMonthsAgo(6);
        },
      },
      uploadForm: new FormClass({
        comp_id  : this.UserInfo.comp_id,
        product  : "",
        order_type: 2,
        spec_id  : {
          init : "",
          check: "required",
        },
        file     : {
          init : "",
          check: "required",
        },
        file_url : {
          init : "",
          check: "required"
        },
      }),
      exportForm: new FormClass({ // 弹窗-生成对应xls的参数表单
        searchType : "1",
        searchValue: "",
        create_time: () => [nDaysAgo(30)+ " 00:00:00", nDaysAgo(0)+ " 00:00:00"],
        comp_id    : "",
        order_by   : "",
        order_state: 1,
      }),
      searchForm : { // 查询表单用的数据
        searchType  : "4",
        searchValue : "",
        create_time : ["",""],
        comp_id     : "",
        order_by    : "",
        order_state : "0",
        category_id : 0,
      },
      searchData: {
        searchType  : "4",
        searchValue : "",
        create_time : ["",""],
        comp_id     : "",
        order_by    : "",
        order_state : "0",
        category_id : 0,
      }, // 检索范围
      // 表格相关
      icon  : "dns",
      title : this.$I18n("order_info"),
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      openModalType: "",
      openModal: false,
      modalTitle : "",
      modalTableData: [],
      import_currentPage : 1,
      import_pageSize : 10,
      import_total : 0,

      productData:[],
      specData : [],
      selectedSpec:{},

      importableData:[],
      import_record_total:0,
      import_record_currentPage : 1,

      orderClass: [], // 商品类型
    };
  },
  mounted : function() {
    this.api_getComp()
    .then(() => {
      this.api_getPageData();
    });
    this.api_getOrderClass();

  },
  watch: {
    'uploadForm.Form.comp_id':{
      handler(newValue){
        if(newValue){
          this.uploadForm.Form.product = "";
          this.uploadForm.Form.spec_id = "";
          this.api_getSpec(newValue);
        }
      },
      immediate: true,
      deep: true,
    },
    'uploadForm.Form.product':{
      handler(newValue){
        if(newValue){
          this.uploadForm.Form.spec_id = newValue;
        }
      },
      immediate: true,
      deep: true,
    },
    // 'uploadForm.Form.spec_id':{
    //   handler(newValue){
    //     let spec = this.specData.filter(item => item.id == newValue)[0]
    //     if(!spec){
    //       this.selectedSpec = {};
    //     } else {
    //       this.selectedSpec = {...spec}
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
    import_currentPage(){
      this.api_getXlsData();
    },
    import_record_currentPage(){
      this.api_getImportOrder();
    },
  },
  methods: {
    api_getOrderClass(){
      this.$api.getGoodClass({})
        .then(this.$Then(res => {
          this.orderClass = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.orderClass = [];
        }))
    },
    modal_refund_order(){
      this.$api.setOrderRefund({
        order_id: this.refundOrderForm.Form.order_id,
        price   : this.refundOrderForm.Form.refund_price,
        reason  : this.refundOrderForm.Form.reason,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.refund.close();
        }))
        .catch(err => {
          if(err.code === 3009){
            this.$errorMsg(this.$I18n("error_code_3009"));
          } else {
            this.$errorMsg(this.$I18n("fail_num"));
          }
        })
    },
    goRefund(order){
      if(!order){
        return
      }
      this.$api.getOrderDetail({...order})
        .then(this.$Then(res => {
          var refund_price = "0.00";
          if(!isNaN(res.data.order_price) && !isNaN(res.data.use_price)){
            refund_price = (parseFloat(res.data.order_price) - parseFloat(res.data.use_price)).toFixed(2);
            if(refund_price <= 0){
              this.$errorMsg(this.$I18n("cant_refund"));
              return
            } else {
              refund_price = refund_price + "";
            }
          } else {
            this.$errorMsg(this.$I18n("cant_refund"));
            return
          }
          this.refundOrderForm.Update({
            ...order,
            ...res.data,
            reason: "",
            refund_price: refund_price,
          })
          this.$refs.refund.open();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    form_uploadOrder(){
      this.$refs.import_order.open();
      this.uploadForm.Reset();
    },
    modal_import_submit(){
      if(this.uploadForm.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return
      }
      this.$api.addImportOrder({
        order_type:this.uploadForm.Form.order_type,
        file_path: this.uploadForm.Form.file_url,
        comp_id:   this.uploadForm.Form.comp_id,
        spec_id:   this.uploadForm.Form.spec_id,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.import_order.close();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    form_uploadOrderList(){
      this.import_record_currentPage = 1;
      this.api_getImportOrder();
    },
    api_getImportOrder(){
      this.$api.getImportOrder({
        page_size:10,
        page_no: this.import_record_currentPage,
      })
        .then(this.$Then(res => {
          this.import_record_total = res.count;
          this.importableData = res.data.map(item => {
            let comp_name = ""
            let comp = this.compData.filter(compItem => {
              return item.comp_id === compItem.comp_id
            })
            if(comp.length > 0) {
              if(comp[0].comp_short_name){
                comp_name = comp[0].comp_short_name
              } else {
                comp_name = comp[0].comp_name
              }
            }
            return {
              ...item,
              comp_name,
              create_time: timestampToString(item.gmt_create * 1000),
              update_time: timestampToString(item.gmt_update * 1000),
            }
          });
          this.$refs.import_record.open();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    modal_file_input(){ // 点击上传文件
      this.$refs.inputFile.click()
    },
    onChange ($event) { // (file发生变化)
      this.onFileSelected($event)
    },
    onFileSelected ({ target, dataTransfer }) { // 选择文件
      const files = target.files || dataTransfer.files;
      if(files[0].type.includes(".sheet")){
        this.uploadForm.Form.file = this.getFileName(files, target);
      } else {
        this.$errorMsg(this.$I18n("need_xlsx"))
      }
    },
    getFileName (files, target) { // 获取文件名
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        this.uploadForm.Form.file_url = ""
        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData) // api: /open/file/upload
          .then(this.$Then(res => {
            this.uploadForm.Form.file_url = res.data
          }))
          .catch(this.$Catch(this.$I18n("file_error"),() => {
            this.uploadForm.Form.file = ""
          }))
        return files[0].name
      }

      return null
    },
    jump_month(to){ // 便捷选项点以后可以快速跳到特定的日子
      if(to == 1){ //  这个月
        this.exportForm.Form.create_time = [
          nMonthsAgo(0) + " 00:00:00",          // xx月01日 
          nDaysAgo(0, Date.now()) + " 00:00:00" // 今天
        ]
      } else if (to == 2) {
        this.exportForm.Form.create_time = [
          nMonthsAgo(1) + " 00:00:00",          // xx-1月 01日 
          nDaysAgo(0, new Date(nMonthsAgo(0)).getTime() - 1000* 60* 60* 24) + " 00:00:00"  // xx-1月 最后一天
        ]
      }
    },
    form_changeSearchData(){
      this.searchData = {
        comp_id : this.searchForm.comp_id,
        order_by : "",
        order_state : parseInt(this.searchForm.order_state),
        pay_order_id : "",
        app_id : "",
        user_id : "",
        order_id : "",
        link_id : "",
        start_time : this.searchForm.create_time ?this.searchForm.create_time[0] :"",
        end_time   : this.searchForm.create_time ?this.searchForm.create_time[1].split(" ")[0]+" 23:59:59" :0,
        gmt_start  : 0,
        gmt_end    : 0,
        link_type : parseInt(this.searchForm.searchType),
        category_id: this.searchForm.category_id,
      }
      if(this.searchData.start_time){
        this.searchData.gmt_start = parseInt(new Date(this.searchData.start_time).getTime() / 1000)
        this.searchData.gmt_end   = parseInt(new Date(this.searchData.end_time).getTime() / 1000)
      }
      switch(this.searchForm.searchType){
        case "1":
          this.searchData.order_id = this.searchForm.searchValue;
          break;
        case "2":
          this.searchData.pay_order_id = this.searchForm.searchValue;
          break;
        case "3":
          this.searchData.app_id = this.searchForm.searchValue;
          break;
        case "4":
          this.searchData.user_id = this.searchForm.searchValue;
          break;
        case "5":
          this.searchData.link_id = this.searchForm.searchValue;
          break;
        case "6":
          this.searchData.platform_order_id = this.searchForm.searchValue;
          break;
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
    form_downloadXlsx(){
      this.api_getXlsData();
      this.import_currentPage = 1;
      this.openModalType = "import"
      this.modalTitle = this.$I18n("export_record");
      this.$refs.modal.open();
    },
    get_file(){
      this.openModalType = "create_xls"
      this.modalTitle = this.$I18n("create_xls");
      this.$refs.modal.open();

      // this.jump_month = 0;
      this.exportForm.Reset()
    },
    api_buildXls(sendData){
      this.$api.buildXls(sendData)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("get_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getSpec(compId){
      this.$api.getGood({
        comp_id: compId,
      })
        .then(this.$Then(resData => {
          this.productData = resData.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.specData = [];
        }))
    },
    api_getXlsData(){
      this.$api.getXlsData({ // api: /mall/order/export/get
        page_no  : this.import_currentPage,
        page_size  : this.import_pageSize,
      })
        .then(this.$Then(res => {
          this.modalTableData = res.data.map(item => {
            let state_name = ""
            if(item.state === 1){
              state_name = this.$I18n("is_export")
            } else if(item.state === 2){
              state_name = this.$I18n("export_fail")
            } else if(item.state === 3){
              state_name = this.$I18n("export_succ")
            }
            let comp_name = ""
            let comp = this.compData.filter(compItem => {
              return item.comp_id === compItem.comp_id
            })
            if(comp.length > 0) {
              if(comp[0].comp_short_name){
                comp_name = comp[0].comp_short_name
              } else {
                comp_name = comp[0].comp_name
              }
            }
            return {
              ...item,
              state_name,
              comp_name,
              create_time: timestampToString(item.gmt_create * 1000),
            }
          })
          this.import_total = res.count
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalTableData = [];
          this.import_total = 0;
        }))
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getBuyList({ // api: /mall/order/query
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
          // 将滚动条置顶
          document.getElementsByClassName("main-panel")[0].scrollTop = 0;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 获取公司信息
    api_getComp (){
      //获取菜单
      return this.$api.getCompanyList({}) // api: /user/company/query
        .then(this.$Then(res => {
          this.compData = res.data;
          if(res.data.some(i => i.comp_id == this.UserInfo.comp_id)){
            this.searchForm.comp_id = this.UserInfo.comp_id;
            this.searchData.comp_id = this.UserInfo.comp_id;
          }
        }))
        .catch(this.$Catch("",() => {
          this.compData = [];
        }))
    },
    // 提交表单
    modal_submit () {
      if(this.openModalType === "delete"){
        this.modal_submitDel();
      } else if (this.openModalType === "add") {
        this.modal_submitAdd();
      } else if (this.openModalType === "edit"){
        this.modal_submitEdit();
      } else if (this.openModalType === "create_xls"){
        if(!this.exportForm.Form.create_time || !this.exportForm.Form.create_time[0] || !this.exportForm.Form.create_time[1]){
          this.$errorMsg(this.$I18n("mst_select_date"))
          return 
        }
        let sendData = {
          comp_id : this.exportForm.Form.comp_id,
          order_by : "",
          order_state : parseInt(this.exportForm.Form.order_state),
          pay_id : "",
          app_id : "",
          user_id : "",
          order_id : "",
          umid : "",
          start_time : this.exportForm.Form.create_time ?this.exportForm.Form.create_time[0] :"",
          end_time   : this.exportForm.Form.create_time ?this.exportForm.Form.create_time[1].split(" ")[0]+" 23:59:59" :0,
          gmt_start  : parseInt(new Date(this.exportForm.Form.create_time[0]).getTime() / 1000),
          gmt_end    : parseInt(new Date(this.exportForm.Form.create_time[1].split(" ")[0]+" 23:59:59").getTime() / 1000),
          link_id :  this.exportForm.Form.searchValue,
          link_type : parseInt(this.exportForm.Form.searchType),
        }
        switch(this.exportForm.Form.searchType){
          case "1":
            sendData.order_id = this.exportForm.Form.searchValue;
            break;
          case "2":
            sendData.pay_id = this.exportForm.Form.searchValue;
            break;
          case "3":
            sendData.app_id = this.exportForm.Form.searchValue;
            break;
          case "4":
            sendData.user_id = this.exportForm.Form.searchValue;
            break;
          case "5":
            sendData.umid = this.exportForm.Form.searchValue;
            break;
        }
        this.api_buildXls(sendData);
      }
    },
  },
  computed: {
    searchValuePlaceHolder(){
      if(this.searchForm.searchType == 1){
        return this.$I18n("pls_input_order_id")
      } else if(this.searchForm.searchType == 2){
        return this.$I18n("pls_input_pay_order_id")
      } else if(this.searchForm.searchType == 3){
        return this.$I18n("pls_input_app_id")
      } else if(this.searchForm.searchType == 4){
        return this.$I18n("pls_input_buy_user_id")
      } else if(this.searchForm.searchType == 5){
        return this.$I18n("pls_input_umid")
      } else if(this.searchForm.searchType == 6){
        return this.$I18n("pls_input_platform_order_id_2")
      }
      return this.$I18n("pls_input")
    },
    form_refundData(){
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          disable : true,
        },{
          label   : this.$I18n("day_use"),
          keys    : "use_day",
          type    : "input",
          disable : true,
        },{
          label   : this.$I18n("amount_use"),
          keys    : "use_price",
          type    : "input",
          disable : true,
        },{
          label   : this.$I18n("order_amount"),
          keys    : "order_price",
          type    : "input",
          disable : true,
        },{
          label   : this.$I18n("amount_can_refund"),
          keys    : "refund_price",
          type    : "input",
          disable : true,
        },{
          label   : this.$I18n("refund_reason"),
          keys    : "reason",
          type    : "textarea",
        },
      ]
    },
    form_importModalData(){
      return [
        {
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          }),
          required: true,
          placeholder: this.$I18n('pls_select'),
        },{
          label   : this.$I18n("product"),
          keys    : "product",
          type    : "select",
          required: true,
          options : this.productData.map(i => {
            return {
              id  : i.id,
              name: i.name,
            }
          }),
          placeholder: this.$I18n('pls_select'),
        },{
          label   : this.$I18n("order_type"),
          keys    : "order_type",
          type    : "select",
          required: true,
          options : this.$Param.orderTypeList_2.map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          }),
          placeholder: this.$I18n('pls_select'),
        },{
          label   : this.$I18n("select_file"),
          isRequired: true,
          key     : "file",
        }
      ]
    },
    comp_price(){
      let price = this.selectedSpec.comp_price
      if(isNaN(price)){
        return 0
      } else {
        return parseFloat(price)
      }
    },
    searchName () { // 表单-根据查询参数类型返回对应的参数名称
      switch(this.searchForm.searchType){
        case "1":
          return this.$I18n("order_id");
        case "2":
          return this.$I18n("pay_order_id");
        case "3":
          return this.$I18n("app_id");
        case "4":
          return this.$I18n("buy_user_id");
        case "5":
          return this.$I18n("umid");
        case "6":
          return this.$I18n("platform_order_id_2");
        default:
          return this.$I18n("unknow")
      }
    },
    modal_searchName(){ // 弹窗-根据查询参数类型返回对应的参数名称
      switch(this.exportForm.Form.searchType){
        case "1":
          return this.$I18n("order_id");
        case "2":
          return this.$I18n("pay_order_id");
        case "3":
          return this.$I18n("app_id");
        case "4":
          return this.$I18n("buy_user_id");
        case "5":
          return this.$I18n("umid");
        default:
          return this.$I18n("unknow")
      }
    },
    tableData(){ // 表格数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        let orderStateList = {
            1:this.$I18n("success"),
            2:this.$I18n("fail"),
            3:this.$I18n("revoke"),
            4:this.$I18n("undo"),
            5:this.$I18n("refunded"),
        }

        return this.tableInitData.map(item => {
          // 公司
          let company_name = item.comp_name;
          // 状态 | 支付方式
          let state = orderStateList[item.order_state];
          let pay_platform_name = this.$I18n(!item.pay_type ?"none" :this.$Param.payment.getName(item.pay_type, "unknow"));

          let order_class_name = "";
          let class_item = this.orderClass.filter(i => i.id == item.category_id)[0]
          if(class_item){
            order_class_name = class_item.name;
          }
          return {
            ...item,
            order_class_name: order_class_name,
            product_name : "",
            stock_name : "",
            order_fee : 0,
            attr: item.product_attr ?JSON.parse(item.product_attr) :{},
            company_name,
            state,
            pay_platform_name,
            create_time : timestampToString(item.gmt_create * 1000),
            pay_time    : item.gmt_pay ? timestampToString(item.gmt_pay * 1000) : "",
          }
        });
      }
    },
    form_modalData() {
      return [
        {
          label   : this.$I18n("filter_type"),
          keys    : "searchType",
          type    : "select",
          options : [
            {
              id   : "1",
              name : this.$I18n('order_id'),
            },{
              id   : "2",
              name : this.$I18n('pay_order_id'),
            },{
              id   : "3",
              name : this.$I18n('app_id'),
            },{
              id   : "4",
              name : this.$I18n('buy_user_id'),
            },{
              id   : "5",
              name : this.$I18n('umid'),
            },
          ],
          class: "md-layout-item md-size-50",
        },{
          label   : this.modal_searchName,
          keys    : "searchValue",
          type    : "input",
          // required: true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("state"),
          keys    : "order_state",
          type    : "select",
          required: true,
          options : [
            {
              id   : 0,
              name :this.$I18n('all'),
            },{
              id   : 1,
              name :this.$I18n('payed'),
            },{
              id   : 2,
              name :this.$I18n('fail'),
            },{
              id   : 3,
              name :this.$I18n('has_cancel'),
            },{
              id   : 4,
              name :this.$I18n('undo'),
            },{
              id   : 5,
              name :this.$I18n('refunded'),
            },
          ],
          class: "md-layout-item md-size-50",
        },{
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          required: true,
          options : [
            {
              id  : "",
              name: this.$I18n("all"),
            },
            ...this.compData.map(i => {
              return {
                id  : i.comp_id,
                name: i.comp_name,
              }
            })
          ],
          class: "md-layout-item md-size-50",
        },
      ]
    },
  },
}
</script>
<style lang="css" scoped>
/deep/ .md-card .md-subhead{
  opacity: 1 !important;
}
.order-card-title-span{
  color: #A5A5A5;
  padding-right: 24px;
  font-size: 14px;
  font-family: Microsoft YaHei;
}
.order-info-body{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.order-info-body .md-layout-item>div{
  margin-bottom: 8px;
}
/deep/ .md-card-actions.md-alignment-right{
  border-top: 0 !important;
}
/deep/ .md-card-actions.md-alignment-right .md-button.md-info{
  margin-bottom: 0px;
}
/deep/ .md-card-actions.md-alignment-right .md-button.md-info .md-ripple{
  padding: 12px 16px;
}
/deep/ .md-card-actions.md-alignment-right{
  padding-top: 0 !important;
}
</style>
<style lang="scss" scoped>

  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px;
    text-align: left;
  }
  .md-chip{
    cursor:pointer;
    line-height: 24px;
    height: 24px;
    margin: 2px 3px !important;
  }
  .md-chip .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip:hover .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip.md-info{
    background: rgb(0, 188, 212) !important;
  }
  .md-chip.md-danger{
    background: #f44336 !important;
  }
  .md-info{
    margin-top : 0 !important;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    font-weight: 700;
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    font-size: 14px;
    font-weight: 400;
    font-family: Microsoft YaHei;
    color: #A5A5A5;
  }
  .order-card .foot-box .foot-box-right div{
    margin-right : 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
  @media screen and ( max-width: 600px ){
    .md-card .md-subhead {
      margin-left: 0;
    }
    .order-card-title span{
      display:block;
    }
    .foot-box span, .foot-box div{
      width: 50%;
      margin-right: -16px !important;
      margin-left: 16px !important;
    }
    .order-card{
      padding: 16px 0;
    }
  }
</style>
